<template>
  <v-container fluid grid-list-lg>
    <!-- {{ value.datosContacto }} -->
    <!-- {{ errors }} -->
    <v-layout wrap>
      <v-flex xs12>
        <h2>Datos Particulares</h2>
      </v-flex>

      <v-flex lg4 sm6 xs12>
        <v-text-field
          type="text"
          label="Nombre"
          v-model="value.nombre"
          v-validate="'required'"
          data-vv-name="nombre"
          :error-messages="errors.collect('nombre')"
          :disabled="!canModifyDatosParticulares"
          :hint="
            hayCaracteresInvalidosEnNombre
              ? 'Atención: Corregir caracteres inválidos'
              : ''
          "
          :persistent-hint="hayCaracteresInvalidosEnNombre"></v-text-field>
      </v-flex>

      <v-flex lg4 sm6 xs12>
        <v-text-field
          label="Apellido"
          v-model="value.apellido"
          v-validate="'required'"
          data-vv-name="apellido"
          :error-messages="errors.collect('apellido')"
          :disabled="!canModifyDatosParticulares"
          :hint="
            hayCaracteresInvalidosEnApellido
              ? 'Atención: Corregir caracteres inválidos'
              : ''
          "
          :persistent-hint="hayCaracteresInvalidosEnApellido"></v-text-field>
      </v-flex>

      <v-flex lg4 class="hidden-md-and-down"> </v-flex>

      <v-flex lg2 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoDocumentoId"
          :items="listTiposDocumento"
          item-text="descripcion"
          item-value="id"
          label="Tipo Doc."
          :menu-props="{ minWidth: '200' }"
          :disabled="!canModifyDatosParticulares"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-text-field
          label="Documento"
          v-model="value.documento"
          v-validate="'required'"
          data-vv-name="documento"
          :disabled="!canModifyDatosParticulares"></v-text-field>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoSexoId"
          :items="listSexos"
          item-text="descripcion"
          item-value="id"
          label="Sexo"
          :menu-props="{ minWidth: '200' }"
          :disabled="!canModifyDatosParticulares"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-text-field
          label="Cuil"
          v-model="value.cui"
          mask="##-########-#"
          clearable
          v-validate="'required'"
          data-vv-name="cuil"
          :disabled="!canModifyDatosParticulares">
          <template v-slot:prepend>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="calcularCui">help_outline</v-icon>
              </template>
              Calcular Cuil en base a Documento y Sexo
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-text-field
          label="Fecha Nacimiento"
          v-model="value.fechaNacimiento"
          type="date"
          prepend-icon="event"
          v-validate="'required'"
          data-vv-name="fecha de nacimiento"
          :disabled="!canModifyDatosParticulares"></v-text-field>
      </v-flex>

      <v-flex lg5 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoSituacionLaboralId"
          :items="listSituacionesLaborales"
          :hint="hintSituacionLaboral"
          persistent-hint
          item-text="descripcion"
          item-value="id"
          label="Situación Laboral Principal"
          :menu-props="{ minWidth: '200' }"
          :disabled="!canModifyDatosParticulares"></v-autocomplete>
      </v-flex>
      <v-flex lg2 sm6 xs12>
        <v-autocomplete
          v-model="value.empleo.diaCobroId"
          :items="listDiasCobro"
          item-text="descripcion"
          item-value="id"
          label="Día de Cobro"
          :menu-props="{ minWidth: '200' }"
          :readonly="esPasivoAnses"></v-autocomplete>
      </v-flex>

      <v-flex lg2 class="hidden-md-and-down"> </v-flex>

      <v-flex>
        <v-layout>
          <v-flex>
            <app-domicilio-editor
              :domicilioEditor="value.domicilios[0]"
              :provincias="provincias"></app-domicilio-editor>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <h2>Datos de Contacto</h2>
      </v-flex>

      <v-flex>
        <v-layout wrap>
          <v-flex lg4 sm6 xs12>
            <!-- <v-text-field
              label="Email"
              v-validate="'required|email'"
              v-model="value.datosContacto.email"
              data-vv-name="email"
              :error-messages="errors.collect('email')"
              hint="Dato Obligatorio"
              persistent-hint
              v-if="mailObligatorio"
            ></v-text-field>
            <v-text-field
              label="Email"
              v-validate="'email'"
              v-model="value.datosContacto.email"
              data-vv-name="email"
              :error-messages="errors.collect('email')"
              hint="Dato Opcional"
              persistent-hint
              v-else
            ></v-text-field> -->
            <v-text-field
              label="Email"
              v-validate="'email'"
              v-model="value.datosContacto.email"
              data-vv-name="email"
              :error-messages="errors.collect('email')"
              hint="Dato Opcional"
              persistent-hint></v-text-field>
          </v-flex>

          <v-flex lg4 sm6 xs12>
            <v-text-field
              label="Facebook"
              v-model="value.datosContacto.facebook"
              hint="Dato Opcional"
              persistent-hint></v-text-field>
          </v-flex>

          <!-- <v-flex lg4 sm6 class="hidden-lg-and-down"> </v-flex> -->

          <v-flex lg4 sm6 xs12>
            <v-text-field
              label="Instagram"
              v-model="value.datosContacto.instagram"
              hint="Dato Opcional"
              persistent-hint></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex>
        <v-layout wrap>
          <v-flex>
            <v-list>
              <v-list-item
                v-for="telefono in value.datosContacto.telefonos.filter(
                  (tel) => !tel.anulado,
                )"
                :key="telefono.id">
                <app-telefono-editor
                  :telefonoEditor="telefono"
                  modoSimple="true"></app-telefono-editor>
              </v-list-item>
            </v-list>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 v-show="false">
        <h2>Datos del Empleo</h2>
      </v-flex>
      <v-flex v-if="false">
        <app-empleo-editor
          :empleo="value.empleo"
          :visible="visible"
          ref="editorControl"
          modo="comer-web">
        </app-empleo-editor>
      </v-flex>

      <v-row>
        <v-col>
          <v-btn color="accent" text @click="legajoGuardado(false)">
            Cancelar
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-btn color="primary" @click="confirmarModificacion()">
            Confirmar
          </v-btn>
        </v-col>
      </v-row>
    </v-layout>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";

//import DatosContacto from '../legajo/contacto';

import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      listTiposDocumento: [],
      listNacionalidades: [],
      listSexos: [],
      listTiposIva: [],
      listSituacionesLaborales: [],
      listEstadosCiviles: [],
      provincias: [],
      listDiasCobro: [],
      hintSituacionLaboral: "",
    };
  },
  components: {
    //'datos-contacto': DatosContacto,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
    },
    legajoGuardado: {
      type: Function,
    },
    mailObligatorio: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    this.loadTiposDocumento();
    this.loadNacionalidades();
    this.loadEstadosCiviles();
    this.loadTiposIva();
    this.loadSituacionesLaborales();
    this.loadSexo();
    this.loadProvincias();
    this.loadDiasCobro();
    console.log(this.value);
  },
  watch: {
    "value.nombre": function () {
      this.value.nombre = this.value.nombre.toUpperCase();
    },
    "value.apellido": function () {
      this.value.apellido = this.value.apellido.toUpperCase();
    },
    "value.tipoSituacionLaboralId": function () {
      this.setHintSituacionLaboral();

      // modifico la situación del empleo predeterminado
      if (this.value.empleo) {
        this.value.empleo.situacionLaboralId =
          this.value.tipoSituacionLaboralId;
      }
    },
  },
  computed: {
    ...mapGetters(["user", "DebugModeOn", "checkCanAccess"]),
    canModifyDatosParticulares: function () {
      return this.checkCanAccess("ap-modifica-datos-particulares-legajo");
    },
    // pasivos ANSES: el día de cobro lo determina el calendario, no se edita a mano
    esPasivoAnses: function () {
      return (
        Number(this.value.tipoSituacionLaboralId) === 4 ||
        (this.value.empleo != null &&
          [41, 43, 44, 64].includes(
            Number(this.value.empleo.situacionLaboralActividadId),
          ))
      );
    },
    hayCaracteresInvalidosEnNombre: function () {
      // Expresión regular que coincide con cualquier carácter que no sea alfanumérico
      var regex = /[^a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑ]/;

      // console.log(this.value.nombre + ':' + regex.test(this.value.nombre));
      // console.log(this.value.apellido + ':' + regex.test(this.value.apellido));

      return regex.test(this.value.nombre);
    },
    hayCaracteresInvalidosEnApellido: function () {
      // Expresión regular que coincide con cualquier carácter que no sea alfanumérico
      var regex = /[^a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑ]/;

      // console.log(this.value.nombre + ':' + regex.test(this.value.nombre));
      // console.log(this.value.apellido + ':' + regex.test(this.value.apellido));

      return regex.test(this.value.apellido);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async confirmarModificacion() {
      const isUpdate = this.value.id !== "00000000-0000-0000-0000-000000000000";

      // valido (empleo)
      //   var result = await this.$refs.editorControl.validar();
      //   if (!result) return;

      if (
        this.hayCaracteresInvalidosEnApellido ||
        this.hayCaracteresInvalidosEnNombre
      ) {
        this.alertError(
          "Por favor, antes de guardar, corrija los caracteres inválidos en nombre y/o apellido.",
        );
        return;
      }

      await this.$validator.validateAll();

      if (this.errors.items.length > 0) {
        var msg = "";
        for (let i = 0; i < this.errors.items.length; i++) {
          const valError = this.errors.items[i];
          msg = msg + valError.msg + " / ";
        }
        this.alertError(
          "Por favor, verifique los siguientes inconvenientes: " + msg,
        );
        Vue.$log.debug("validation:");
        Vue.$log.debug(this.errors);
        return;
      }

      if (this.value.empleo) {
        if (this.value.empleos.length > 0)
          this.value.empleos[0] = this.value.empleo;
        else this.value.empleos.push(this.value.empleo);
      }

      if (this.value.tipoSituacionLaboralId == 0)
        this.value.tipoSituacionLaboralId =
          this.value.empleo.situacionLaboralId;

      for (let i = 0; i < this.value.datosContacto.telefonos.length; i++) {
        const tel = this.value.datosContacto.telefonos[i];
        if (tel.numero == "") {
          this.alertError(
            "Por favor, complete los teléfonos requeridos antes de confirmar.",
          );
          return;
        }
        if (!tel.telefonoValidado) {
          this.alertError(
            "Por favor, valide todos los teléfonos ingresados, y luego confirme nuevamente.",
          );
          return;
        }
      }

      if (!this.value.datosContacto.telefonos[0].telefonoValidado) {
        this.alertError(
          "Por favor, realice la verificación Via SMS del Teléfono Titular (1).",
        );
        return;
      }

      //  console.log ('personaDto a guardar')
      //  console.log (this.value)

      try {
        this.loading = true;

        let result;

        if (isUpdate)
          result = await http.put(
            "personas",
            JSON.stringify({ persona: this.value }),
          );
        else
          result = await http.post(
            "personas",
            JSON.stringify({ persona: this.value }),
          );

        console.log("result");
        console.log(result);

        // recargo los datos
        this.loadPersona(result.entity.id);

        this.alertSuccess("Los cambios han sido guardados.");

        // aviso que guardó OK
        this.legajoGuardado(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadPersona(personaId) {
      this.loading = true;
      try {
        var result = await http.get("personas/" + personaId);

        var model = result;

        // trato las fechas
        var dob = this.$moment(model.fechaNacimiento).format("YYYY-MM-DD"); // Todo: ver qué pasa cuando graba
        model.fechaNacimiento = dob;

        if (model.empleo != null) {
          var fi = this.$moment(model.empleo.fechaIngreso).format("YYYY-MM-DD");
          model.empleo.fechaIngreso = fi;
        }

        // actualizo los datos
        this.value.id = model.id;
        this.value.empleo = model.empleo;
        this.value.empleos = model.empleos;
        this.value.telefonos = model.telefonos;
        this.value.domicilios = model.domicilios;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async calcularCui() {
      this.loading = true;
      try {
        var result = await http.put(
          "personas/calcularcui",
          JSON.stringify({
            documento: this.value.documento,
            sexoId: this.value.tipoSexoId,
          }),
        ); // traigo todas
        this.value.cui = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    setHintSituacionLaboral() {
      var hint = "";
      for (
        let index = 0;
        index < this.listSituacionesLaborales.length;
        index++
      ) {
        const item = this.listSituacionesLaborales[index];
        if (item.id == this.value.tipoSituacionLaboralId) {
          if (item.anulado == true)
            hint = "La situación está anulada, intente cambiar por una activa";

          if (item.requiereEmpleo) {
            if (hint != "") hint = hint + " y además, ";

            hint = hint + "La situación requiere el ingreso de datos laborales";
          }
        }
      }

      this.hintSituacionLaboral = hint;
    },
    async loadTiposDocumento() {
      this.loading = true;
      try {
        var result = await http.get("tiposdocumento"); // traigo todas
        this.listTiposDocumento = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadNacionalidades() {
      this.loading = true;
      try {
        var result = await http.get("tiposnacionalidad"); // traigo todas
        this.listNacionalidades = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadosCiviles() {
      this.loading = true;
      try {
        var result = await http.get("tiposestadocivil"); // traigo todas
        this.listEstadosCiviles = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDiasCobro() {
      this.loading = true;
      try {
        var result = await http.get("tiposdiacobro"); // traigo todas
        this.listDiasCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposIva() {
      this.loading = true;
      try {
        var result = await http.get("tiposivapersona"); // traigo todas
        this.listTiposIva = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales"); // traigo todas
        this.listSituacionesLaborales = result.list;

        this.setHintSituacionLaboral();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSexo() {
      this.loading = true;
      try {
        var result = await http.get("tipossexo"); // traigo todas
        this.listSexos = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProvincias() {
      this.loading = true;
      try {
        var result = await http.get("provincias"); // traigo todas
        this.provincias = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
  },
};
</script>
